import { Card, Flex } from '@buffer-mono/popcorn'

import { SectionCard } from '../../../components/SectionCard'

import styles from './BlankTopPosts.module.css'

import type { JSX } from 'react'

const PLACEHOLDER_CARDS = [0, 1, 2, 3, 4]

/**
 * Five blank post cards. Rendered on their own so a caller can place them in a
 * different container — the public preview drops them into the real Top Posts
 * grid so the placeholder cards sit where the loaded ones will.
 */
export function BlankTopPostCards(): JSX.Element {
  return (
    <>
      {PLACEHOLDER_CARDS.map((card) => (
        <Card key={card} padding="small" className={styles.postCard}>
          <Flex justify="between" align="center">
            <Flex aria-hidden className={styles.rankBar} />
            <Flex aria-hidden className={styles.metricBar} />
          </Flex>
          <Flex gap="sm" justify="between" align="start">
            <Flex direction="column" gap="2xs" className={styles.textColumn}>
              <Flex aria-hidden className={styles.timeBar} />
              <Flex aria-hidden className={styles.textLineWide} />
              <Flex aria-hidden className={styles.textLineNarrow} />
            </Flex>
            <Flex aria-hidden className={styles.thumbnail} />
          </Flex>
        </Card>
      ))}
    </>
  )
}

/**
 * Empty-state preview of the Top 5 Posts section — five blank post cards that
 * tease the layout users get once a channel is connected and data flows in.
 */
export function BlankTopPosts(): JSX.Element {
  return (
    <SectionCard>
      <SectionCard.Header>
        <SectionCard.Title>Top 5 Posts</SectionCard.Title>
      </SectionCard.Header>
      <Flex gap="sm" wrap="wrap" fullWidth>
        <BlankTopPostCards />
      </Flex>
    </SectionCard>
  )
}
